module.exports = __webpack_public_path__ + "img/20.cde56b62.png";